import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV_LINKS } from "../config/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white relative overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 lg:py-20 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={SITE.logoWhite}
              alt="Centro Studi Forma Futuro"
              className="h-12 w-auto mb-6"
            />
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">
              Centro studi che si occupa di orientamento e percorsi di
              formazione: diplomi, lauree, formazione professionale e
              certificazioni.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300/80 mb-5">
              Navigazione
            </p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-white/70 hover:text-sky-300 transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300/80 mb-5">
              Contatti
            </p>
            <ul className="space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-sky-300 shrink-0" />
                <span data-testid="footer-phone">{SITE.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-sky-300 shrink-0" />
                <span data-testid="footer-email">{SITE.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-sky-300 shrink-0" />
                <span data-testid="footer-address">{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {SITE.name}. Tutti i diritti riservati.
          </p>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="text-xs text-white/40 hover:text-sky-300 transition-colors duration-200"
          >
            Privacy Policy
          </Link>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-xs text-white/40 hover:text-sky-300 transition-colors duration-200"
          >
            Area riservata
          </Link>
          <p className="text-xs text-white/40 font-serif-editorial italic">
            {SITE.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};
